module.exports = __webpack_public_path__ + "pc/img/body_basic 1.b9b1a81d.jpg";